import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// Mobile (portrait) images
import imgHomeMobile from '../images/הבית של גל בנחלה 15.webp';
import imgRenovationMobile from '../images/הבית של גילה 10.webp';
import imgConsultMobile from '../images/הבית של סיון 25.webp';
import s from './Services.module.css';

gsap.registerPlugin(ScrollTrigger);

const SERVICES = [
  { num: '01', title: 'תכנון וליווי בניה מלא', sub: 'בית חדש מאפס', img: '/hero-images/sivan-31.webp', imgMobile: imgHomeMobile, forWho: 'בעלי מגרש, נחלה או כל שטח אחר שמעוניינים לבנות בית מאפס או שיפוץ מהיסוד, וזקוקים לכתובת מקצועית אחת שתלווה ותוביל את התהליך כולו.', includes: ['תכנון אדריכלי מלא', 'הגשה להיתר בנייה', 'עיצוב פנים מלא', 'בחירת חומרי גמר', 'תכנון תאורה וחשמל', 'ליווי ופיקוח בשטח'], process: ['גיבוש פרוגרמה וקונספט תכנוני לפרויקט על פי צרכי והעדפות בני הבית', 'בחינת האפשרויות התכנוניות השונות והצגת חלופות תכנון', 'תכנון אדריכלי מלא של החלופה הנבחרת והגשה לרשויות לקבלת היתר בנייה', 'הוצאת סט תוכניות עבודה מלא ותוכניות עיצוב משלימות לביצוע', 'תיאום מול היועצים השונים בפרויקט', 'בחירות חומרים, פרטי עיצוב וגמרים', 'ליווי הבנייה בשטח והנחיית העובדים ובעלי המקצוע עד לסיום מלא של הפרויקט'], whatsappMsg: 'היי לירית, מתעניין/ת בתכנון וליווי בניה מלא לבית חדש' },
  { num: '02', title: 'שיפוץ ועיצוב', sub: 'בית קיים או דירה', img: '/hero-images/muktenet-3.webp', imgMobile: imgRenovationMobile, forWho: 'כל מי שמעוניין לקחת נכס קיים ולהתאים אותו לצרכים המשתנים של המשפחה, לשדרג אותו מבחינה עיצובית, לבצע הרחבה או תוספת, או לשנות מהותית את המצב הקיים.', includes: ['תכנון מחדש של חללים', 'עיצוב פנים מלא', 'בחירת חומרי גמר וריהוט', 'תכנון תאורה', 'ליווי השיפוץ בשטח'], process: ['גיבוש פרוגרמה וקונספט תכנוני לפרויקט על פי המצב הקיים וצרכי בני הבית', 'בחינת האפשרויות התכנוניות השונות והצגת חלופות תכנון', 'הגשה לרשויות לקבלת היתר בנייה על פי הצורך', 'תכנון אדריכלי מפורט כולל סט תוכניות עבודה ועיצוב לביצוע', 'בחירות חומרים, פרטי עיצוב וגמרים', 'ליווי הבנייה בשטח והנחיית העובדים ובעלי המקצוע עד לסיום מלא של הפרויקט'], whatsappMsg: 'היי לירית, מתעניין/ת בשיפוץ ועיצוב לבית/דירה קיימים' },
  { num: '03', title: 'פגישת ייעוץ', sub: 'כיוון והכוונה מקצועית', img: '/hero-images/zohar-19.webp', imgMobile: imgConsultMobile, forWho: 'לכל מי שעומד לפני תהליך של תכנון ובנייה וצריך כיוון והכוונה: אם אתם לקראת קניית בית, דירה או מגרש ומתלבטים האם ואיך אפשר להתאים אותו בדיוק עבורכם; אם אתם רוצים לשנות מצב קיים בבית אך רוצים לבדוק קודם מה האפשרויות ומה הדרך הטובה ביותר; ואם התחלתם תהליך תכנון ואינכם בטוחים בבחירות שעשיתם או אם אתם בדרך הנכונה.', includes: ['מבט מקצועי חיצוני', 'זיהוי בעיות פוטנציאליות', 'המלצות והכוונה', 'מענה על כל השאלות'], process: ['פגישה פרונטלית של כ-3 שעות במשרד או בשטח, שבה נעלה את כל הסוגיות שמטרידות אתכם ואת כל הפתרונות האפשריים - תכנונית ומעשית.'], whatsappMsg: 'היי לירית, מתעניין/ת בפגישת ייעוץ מקצועית' },
];

export default function Services({ onOpenLead }) {
  const [hovered, setHovered] = useState(null);
  const [modal, setModal] = useState(null);
  const [mobileActive, setMobileActive] = useState(0);
  const sectionRef = useRef(null);
  const mobileRef = useRef(null);
  const mobileImgRefs = useRef([]);

  const savedScroll = useRef(0);
  const openModal = (svc) => {
    setModal(svc);
    savedScroll.current = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScroll.current}px`;
    document.body.style.width = '100%';
  };
  const closeModal = () => {
    setModal(null);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScroll.current);
  };

  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape' && modal) closeModal(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [modal]);

  // Mobile: pinned scroll through services with image wipe
  useEffect(() => {
    if (window.innerWidth > 768) return;
    if (!mobileRef.current) return;
    const ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: mobileRef.current,
        start: 'top top',
        end: `+=${window.innerHeight * 3}`,
        pin: mobileRef.current,
        scrub: 0.6,
        onUpdate: (self) => {
          setMobileActive(Math.min(Math.floor(self.progress * SERVICES.length), SERVICES.length - 1));
        },
      });
    }, mobileRef);
    return () => ctx.revert();
  }, []);

  // Mobile image transition — CSS-driven via class, no GSAP imperative calls
  // (prevents flicker when scrub rapidly toggles states)

  const handleLeadFromService = () => {
    closeModal();
    if (typeof onOpenLead === 'function') {
      // Defer slightly so the service modal unmount doesn't eat the next modal
      setTimeout(onOpenLead, 120);
    }
  };

  return (
    <section className={s.section} ref={sectionRef} id="services">
      {/* ===== DESKTOP: 4 in a row with hover ===== */}
      <div className={s.desktop}>
        <div className={s.header}>
          <h2 className={s.headerH}>שירותי הסטודיו</h2>
        </div>

        <div className={s.grid} onMouseLeave={() => setHovered(null)}>
          {SERVICES.map((svc, i) => (
            <div key={i} className={s.item}
              onMouseEnter={() => setHovered(i)}
              onClick={() => openModal(svc)}>
              <img src={svc.img} alt={svc.title} className={s.itemImg} />
              <div className={s.itemContent}>
                <span className={s.itemNum}>{svc.num}</span>
                <h3 className={s.itemTitle}>{svc.title}</h3>
                <p className={s.itemSub}>{svc.sub}</p>
                <button className={s.itemBtn} onClick={(e) => { e.stopPropagation(); openModal(svc); }}>
                  <span>לפרטים</span><span className={s.itemArrow}>←</span>
                </button>
              </div>
            </div>
          ))}
          {/* Full-width hover overlay - pointer-events only on button */}
          <div className={`${s.hoverOverlay} ${hovered !== null ? s.hoverOn : ''}`}>
            {hovered !== null && <img src={SERVICES[hovered].img} alt="" className={s.hoverBg} />}
            <div className={s.hoverDark} />
            {hovered !== null && (
              <div className={s.hoverContent}>
                <span className={s.hoverNum}>{SERVICES[hovered].num}</span>
                <h3 className={s.hoverTitle}>{SERVICES[hovered].title}</h3>
                <p className={s.hoverSub}>{SERVICES[hovered].sub}</p>
                <button className={s.hoverBtn} onClick={() => openModal(SERVICES[hovered])}>
                  <span>לפרטים נוספים</span><span className={s.hoverArrow}>←</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ===== MOBILE: pinned scroll with image wipe ===== */}
      <div className={s.mobile} ref={mobileRef}>
        {/* Full-bleed image stack */}
        <div className={s.mobileImgs}>
          {SERVICES.map((svc, i) => (
            <img
              key={i}
              ref={el => mobileImgRefs.current[i] = el}
              src={svc.imgMobile || svc.img}
              alt={svc.title}
              className={`${s.mobileImg} ${i === mobileActive ? s.mobileImgActive : ''} ${i < mobileActive ? s.mobileImgPast : ''}`}
            />
          ))}
          <div className={s.mobileImgOv} />
        </div>

        {/* Architectural corner marks */}
        <span className={s.mobileCorner} data-corner="tl" />
        <span className={s.mobileCorner} data-corner="tr" />
        <span className={s.mobileCorner} data-corner="bl" />
        <span className={s.mobileCorner} data-corner="br" />

        {/* Editorial masthead */}
        <div className={s.mobileHeader}>
          <span className={s.mHeaderLine} />
          <h2 className={s.headerH}>שירותי הסטודיו</h2>
          <span className={s.mHeaderLine} />
        </div>

        {/* Progress indicator — vertical numeric */}
        <div className={s.mobileCounter} aria-hidden="true">
          <span className={s.mCounterNow}>{SERVICES[mobileActive].num}</span>
          <span className={s.mCounterBar} />
          <span className={s.mCounterTotal}>{String(SERVICES.length).padStart(2, '0')}</span>
        </div>

        {/* Framed editorial card */}
        <div className={s.mobileCardWrap}>
          <div className={s.mobileCard} key={mobileActive}>
            <span className={s.mCardCornerTL} />
            <span className={s.mCardCornerTR} />
            <span className={s.mCardCornerBL} />
            <span className={s.mCardCornerBR} />

            <h3 className={s.mCardTitle}>{SERVICES[mobileActive].title}</h3>
            <button className={s.mCardBtn} onClick={() => openModal(SERVICES[mobileActive])}>
              <span className={s.mCardBtnText}>לפרטים נוספים</span>
              <span className={s.mCardBtnArrow} aria-hidden="true">←</span>
            </button>
          </div>
        </div>

        {/* Pips */}
        <div className={s.mobilePips}>
          {SERVICES.map((_, i) => (
            <span key={i} className={`${s.mobilePip} ${i === mobileActive ? s.mobilePipOn : ''}`} />
          ))}
        </div>
      </div>

      {/* ===== MODAL (shared, portaled) ===== */}
      {modal && createPortal(
        <div className={s.modal} onClick={closeModal}>
          <span className={s.corner} data-corner="tl" />
          <span className={s.corner} data-corner="tr" />
          <span className={s.corner} data-corner="bl" />
          <span className={s.corner} data-corner="br" />

          <button className={s.modalClose} onClick={closeModal} aria-label="סגירה">
            <span />
            <span />
          </button>

          <div className={s.modalInner} onClick={e => e.stopPropagation()}>
            {/* Framed architectural hero */}
            <figure className={s.modalHero}>
              <img src={modal.img} alt={modal.title} className={s.modalHeroImg} />
              <div className={s.modalHeroOv} />
            </figure>

            {/* Editorial caption below hero */}
            <div className={s.modalHeroText}>
              <h2 className={s.modalTitle}>{modal.title}</h2>
              <p className={s.modalSubtitle}>{modal.sub}</p>
            </div>

            <div className={s.modalBody}>
              <article className={s.modalSection}>
                <h4 className={s.modalSectionTitle}>למי מתאים</h4>
                <p className={s.modalText}>{modal.forWho}</p>
              </article>

              <article className={s.modalSection}>
                <h4 className={s.modalSectionTitle}>מה כולל השירות</h4>
                <ul className={s.modalList}>
                  {modal.includes.map((item, i) => (
                    <li key={i} className={s.modalListItem}>{item}</li>
                  ))}
                </ul>
              </article>

              <article className={s.modalSection}>
                <h4 className={s.modalSectionTitle}>תהליך העבודה</h4>
                <div className={s.modalSteps}>
                  {modal.process.map((step, i) => (
                    <div key={i} className={s.modalStep}>
                      <span className={s.stepNum}>{String(i + 1).padStart(2, '0')}</span>
                      <p className={s.stepText}>{step}</p>
                    </div>
                  ))}
                </div>
              </article>

              <div className={s.modalCta}>
                <button
                  type="button"
                  className={s.modalCtaBtn}
                  onClick={handleLeadFromService}
                >
                  <span className={s.modalCtaText}>רוצה להתחיל? דברו איתי</span>
                  <span className={s.modalCtaArrow} aria-hidden="true">←</span>
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </section>
  );
}
